module.exports = __webpack_public_path__ + "static/img/image-2.3a659f56.jpg";